import React, { Component } from 'react'

const THEME_KEY = 'theme'

export default class ThemeSelector extends Component {
  state={
    nameTemplate: {
      pre: './reveal.js/css/theme/',
      post: '.css',
    },
    options: [
      'black','beige','league','moon','night','serif','simple','sky','solarized','white'
    ],
  }
  componentDidMount() {
    const selected = localStorage.getItem(THEME_KEY)
    if (typeof(selected)==='string'&&selected.length>0) {
      this.setState({selected:selected})
    }
  }
  href() {
    const nameTemplate = this.state.nameTemplate
    const selected = this.state.selected
    return `${nameTemplate.pre}${selected}${nameTemplate.post}`
  }
  render() {
    const options = this.state.options||[]
    const selected = this.state.selected
    const mode = this.props.mode
    /*
    return (
      <React.Fragment>
        <a className="nav-link dropdown-toggle" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i className="fa fa-image" /></a>
        <div className="dropdown-menu" aria-labelledby="navbarDropdown">
          {
            options.map((option,index)=>(
              <a key={index} className="dropdown-item" onClick={()=>{
                if (typeof(option)==='string'&&option.length>0) {
                  this.setState({selected:option}, ()=>{
                    localStorage.setItem(THEME_KEY, option);
                  })
                }
              }}>
                {
                  this.state.selected===option&&
                  <i className="fa fa-check mr-2" />
                }
                <span>{option}</span>
              </a>
            ))
          }
        </div>
        {
          typeof(selected)==='string'&&
          selected.length>0&&
          <link rel="stylesheet" type="text/css" href={this.href()} />
        }
      </React.Fragment>
    )
    */
    if (mode==='link') {
      if (typeof(selected)==='string' && selected.length>0) {
        return (
          <link rel="stylesheet" type="text/css" href={this.href()} />
        )
      }
      return null
    }
    return (
      <div>
        <select className="custom-select"
          value={this.state.selected}
          onChange={(event)=>{
            const value = event.target.value
            if (typeof(value)==='string'&&value.length>0) {
              this.setState({selected:value}, ()=>{
                localStorage.setItem(THEME_KEY, value);
                window.location.reload(true)
              })
            }
          }}
        >
          {
            options.map((option,index)=>(
              <option key={index} value={option}>{option}</option>
            ))
          }
        </select>
        {
          typeof(selected)==='string'&&
          selected.length>0&&
          <link rel="stylesheet" type="text/css" href={this.href()} />
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ThemeSelector.js